import Vue from 'vue'
import App from './App.vue'
import VueYouTubeEmbed from 'vue-youtube-embed'
import axios from 'axios'
import VueMobileDetection from "vue-mobile-detection"
import Swiper, { Autoplay, Mousewheel, Scrollbar } from "swiper";
import i18n from './i18n'
import VueObserveVisibility from 'vue-observe-visibility'
import router from './router'
import Vuelidate from 'vuelidate'
//import VueGtag from "vue-gtag";

Swiper.use([Autoplay, Mousewheel, Scrollbar]);

Vue.use(VueMobileDetection);
Vue.use(VueYouTubeEmbed)
Vue.use(VueObserveVisibility)
Vue.use(Vuelidate)

/*
Vue.use(VueGtag, {
    config: { id: "UA-112609079-1" }
});
 */

Vue.prototype.axios = axios
Vue.prototype.axios.defaults.baseURL = 'https://api.epark.online'

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
